import config from '../config/configDefault';
import moment from 'moment';
import { createSlice } from '@reduxjs/toolkit';
import { updateProfile } from '../containers/ProfileSettingsPage/ProfileSettingsPage.duck';

// ================ Action types ================ //

export const CHANGE_LANGUAGE = 'app/ui/CHANGE_LANGUAGE';

// ================ Slice ================ //

const initialState = {
  disableScrollRequests: [],
  locale: config.localization.locale,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    disableScrolling: (state, action) => {
      const { componentId, disableScrolling } = action.payload;
      const disableScrollRequests = state.disableScrollRequests;
      const componentIdExists = disableScrollRequests.find(c => c.componentId === componentId);

      if (componentIdExists) {
        const disableScrollRequestArray = disableScrollRequests.map(c => {
          return c.componentId === componentId ? { ...c, disableScrolling } : c;
        });
        state.disableScrollRequests = [...disableScrollRequestArray];
      } else {
        state.disableScrollRequests = [...disableScrollRequests, { componentId, disableScrolling }];
      }
    },
    changeUiLanguageAction: (state, action) => {
      const { locale } = action.payload;
      moment.locale(locale);
      state.locale = locale;
    },
  },
});

// ================ Exports ================ //

export const { disableScrolling } = uiSlice.actions;
export default uiSlice.reducer;

// ================ Helper function ================ //

export const manageDisableScrolling = (componentId, shouldDisableScrolling) =>
  disableScrolling({ componentId, disableScrolling: shouldDisableScrolling });

// ================ Selectors ================ //

export const isScrollingDisabled = state => {
  const { disableScrollRequests } = state.ui;
  return disableScrollRequests.some(r => r.disableScrolling);
};

export const changeUiLanguage = locale => uiSlice.actions.changeUiLanguageAction({ locale });

export const changeLanguage = locale => (dispatch, getState, sdk) => {
  localStorage.setItem('language', locale);
  dispatch(changeUiLanguage(locale));
  const params = { privateData: { language: locale } };
  const { currentUser } = getState().user;

  if (!!currentUser) {
    return dispatch(updateProfile(params))
      .catch(e => console.error(e))
      .finally(() => {
        if (typeof window !== 'undefined') window.location.reload();
      });
  }
  if (typeof window !== 'undefined') {
    window.location.reload();
  }
};
